var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, darken } from "@mui/material";
import Text from "../Text";
var Badge = function (_a) {
    var children = _a.children, id = _a.id, color = _a.color, hasBorder = _a.hasBorder;
    return (_jsx(Box, __assign({ "data-testid": "".concat(id, "-question-badge") }, { children: _jsx(Text, __assign({ sx: {
                backgroundColor: color,
                border: hasBorder ? "1px solid ".concat(darken(color, 0.2)) : "none",
                borderRadius: "4px",
                px: 2,
                py: 0.75,
                textTransform: "capitalize",
            }, emphasis: "medium", variant: "body3" }, { children: children })) })));
};
export default Badge;
